import { Routes } from '@angular/router';

import { v2On } from '../v2/ui-v2.guard';

export const settingsRoutes: Routes = [
  {
    path: 'settings',
    canMatch: [v2On],
    loadComponent: () => import('../v2/pages/settings/settings-v2.page').then(m => m.SettingsV2Page)
  },
  {
    path: 'settings',
    loadComponent: () => import('./settings.page').then(m => m.SettingsPage)
  },
  {
    path: 'profile',
    canMatch: [v2On],
    loadComponent: () => import('../v2/pages/settings/profile-v2.page').then(m => m.ProfileV2Page)
  },
  {
    path: 'profile',
    loadComponent: () => import('./profile/profile.page').then(m => m.ProfilePage)
  },
  {
    path: 'blocked-users',
    canMatch: [v2On],
    loadComponent: () => import('../v2/pages/settings/blocked-users-v2.page').then(m => m.BlockedUsersV2Page)
  },
  {
    path: 'blocked-users',
    loadComponent: () => import('./blocked-users/blocked-users.page').then(m => m.BlockedUsersPage)
  },
  {
    path: 'settings/payments',
    canMatch: [v2On],
    loadComponent: () => import('../v2/pages/settings/payments-settings-v2.page').then(m => m.PaymentsSettingsV2Page)
  },
  {
    path: 'settings/payments',
    loadComponent: () => import('./payments/payments.page').then(m => m.PaymentsPage)
  }
];
